import WsPush from "../../store/wsPush";
import AllowNotifications from "../../components/AllowNotifications/AllowNotifications";
import PendingOrders from "./PendingOrders";
import { OrderList } from './OrderList';
import {onOrdersRemovePending} from "../../store/Orders/actions";
import {useDispatch} from "react-redux";

const Orders = () => {
    const dispatch = useDispatch()
    const removePendingOrder = () => dispatch(onOrdersRemovePending(0))

    return (
        <div className="max-w-7xl px-4 sm:px-8 lg:px-10 xl:px-12">
            <WsPush />

            <AllowNotifications />
            <PendingOrders onOrderClick={removePendingOrder} />
            <OrderList />
        </div>
    )
}

export default Orders
